import React, { FC, useContext } from 'react'

import clsx from 'clsx'
import { useFormContext } from 'react-hook-form'

import useEvent from 'Hooks/useEvent'
import amexSrc from 'Icons/shop/cards/amex.svg'
import mastercardSrc from 'Icons/shop/cards/mastercard.svg'
import visaSrc from 'Icons/shop/cards/visa.svg'
import applePaySrc from 'Icons/shop/payment_methods/apple-pay.svg'
import googlePaySrc from 'Icons/shop/payment_methods/google-pay.svg'
import { StepContext } from 'Pages/Checkout/Form'
import { CardBrands, PaymentMethods, ShopCustomerCard } from 'Types'

import { usePayment } from '../../Provider'

const TITLE = {
  [PaymentMethods.APPLE_PAY]: 'Apple Pay',
  [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
}

const ICONS = {
  [PaymentMethods.APPLE_PAY]: <img key={PaymentMethods.APPLE_PAY} alt="Apple Pay" src={applePaySrc} />,
  [PaymentMethods.GOOGLE_PAY]: <img key={PaymentMethods.GOOGLE_PAY} alt="Google Pay" src={googlePaySrc} />,
  [CardBrands.AMERICAN_EXPRESS]: <img key={CardBrands.AMERICAN_EXPRESS} alt="Amex" src={amexSrc} />,
  [CardBrands.MASTERCARD]: <img key={CardBrands.MASTERCARD} alt="Mastercard" src={mastercardSrc} />,
  [CardBrands.VISA]: <img key={CardBrands.VISA} alt="Visa" src={visaSrc} />,
  allBrands() {
    return [this.VISA, this.MASTERCARD, this.AMERICAN_EXPRESS]
  },
}

interface Props {
  card?: ShopCustomerCard
  hasCards?: boolean
  paymentMethod: PaymentMethods
  selected: boolean
}

const PaymentOption: FC<Props> = ({ children, card, hasCards, paymentMethod, selected }) => {
  const { checkouting } = useContext(StepContext)
  const { gateway, tokenizing } = usePayment()
  const { field } = gateway
  const { setValue } = useFormContext()
  const cardId = card?.id
  const isPaymentCard = paymentMethod === PaymentMethods.CARD

  const handleSelect = useEvent(() => {
    setValue(`${field}.paymentMethod`, paymentMethod)
    setValue(`${field}.payByEnteredCard`, !cardId)
    setValue(`${field}.sourceId`, cardId)
  })

  const title = isPaymentCard
    ? card
      ? `•••• ${card.last4}`
      : hasCards
      ? 'Add card'
      : 'Credit card'
    : TITLE[paymentMethod]

  return (
    <div className="checkout-option  checkout-option_payment">
      <div
        className={clsx('checkout-option__control', {
          ['checkout-option__control_selected']: selected,
          ['checkout-option__control_loading']: selected && (checkouting || tokenizing),
        })}
        onClick={handleSelect}
      >
        <div className="checkout-option__inner">
          <div
            className={clsx('checkout-option__payments', {
              ['checkout-option__payments_cards']: isPaymentCard,
            })}
          >
            {isPaymentCard
              ? card
                ? ICONS[card.cardBrand]
                : ICONS.allBrands().map((icon) => icon)
              : ICONS[paymentMethod]}
          </div>
          <span className="ml-3">{title}</span>
        </div>

        {!selected || !children ? null : <div className="my-2">{children}</div>}
      </div>
    </div>
  )
}

export default PaymentOption
